/* eslint-disable no-nested-ternary */
const STATUS = {
  INACTIVE: 'inactive',
  PENDING: 'pending',
  ACTIVE: 'active',
};

const statusSortOrderByStatus = {
  inactive: 0,
  pending: 1,
  active: 2,
};

const STATUS_BY_ORDER_TASK_STATUS = {
  canceled: STATUS.INACTIVE,
  cancelled: STATUS.INACTIVE,
  declined: STATUS.INACTIVE,
  incomplete: STATUS.PENDING,
  pending: STATUS.PENDING,
  processing: STATUS.PENDING,
  action_req: STATUS.PENDING,
  active: STATUS.ACTIVE,
  complete: STATUS.ACTIVE,
};

const FRIENDLY_NAME_BY_ORDER_TASK_STATUS = (orderTaskType, fm) => ({
  canceled: orderTaskType.includes('_plan_')
    ? fm({ id: 'orderView.status.planCanceled' })
    : orderTaskType.includes('bundle')
      ? fm({ id: 'orderView.status.bundleCanceled' })
      : fm({ id: 'orderView.status.canceled' }),
  cancelled: fm({ id: 'orderView.status.canceled' }),
  declined:
    orderTaskType === 'banking' ? fm({ id: 'orderView.status.declined' }) : fm({ id: 'orderView.status.skipped' }),
  incomplete: fm({ id: 'orderView.status.incomplete' }),
  pending: fm({ id: 'orderView.status.orderReceived' }),
  processing: fm({ id: 'orderView.status.processing' }),
  action_req: fm({ id: 'orderView.status.clientActionRequired' }),
  active: orderTaskType.includes('_plan_')
    ? fm({ id: 'orderView.status.planActive' })
    : orderTaskType.includes('bundle')
      ? fm({ id: 'orderView.status.bundleActive' })
      : fm({ id: 'orderView.status.active' }),
  complete: fm({ id: 'orderView.status.complete' }),
});

export const TASK_STATUS_DESCRIPTION = (orderTaskType, fm) => ({
  processing: fm({ id: 'orderView.statusDescription.processing' }),
  pending: fm({ id: 'orderView.statusDescription.pending' }),
  canceled: fm({ id: 'orderView.statusDescription.canceled' }),
  cancelled: fm({ id: 'orderView.statusDescription.canceled' }),
  incomplete: fm({ id: 'orderView.statusDescription.incomplete' }),
  action_req: fm({ id: 'orderView.statusDescription.clientActionRequired' }),
  active: fm({ id: 'orderView.statusDescription.active' }),
  complete: fm({ id: 'orderView.statusDescription.complete' }),
  declined:
    orderTaskType === 'banking'
      ? fm({ id: 'orderView.statusDescription.declinedBanking' })
      : fm({ id: 'orderView.statusDescription.declined' }),
});

export const getWfgIRName = (jurisdiction, fm) => {
  const wfgIRName = {
    AK: fm({ id: 'orderView.taskName.initialReport' }),
    CA: fm({ id: 'orderView.taskName.firstStatementOfInfo' }),
    CT: fm({ id: 'orderView.taskName.firstReport' }),
    GA: fm({ id: 'orderView.taskName.initialReport' }),
    MO: fm({ id: 'orderView.taskName.initialRegistrationReport' }),
    NM: fm({ id: 'orderView.taskName.initialReport' }),
  };
  return wfgIRName[jurisdiction] || fm({ id: 'orderView.taskName.initialReport' });
};

export const getOrderTaskStatusFriendlyName = (orderTask, fm) =>
  orderTask
    ? FRIENDLY_NAME_BY_ORDER_TASK_STATUS(orderTask.orderTaskType, fm)[orderTask.orderTaskStatus] ||
      fm({ id: 'orderView.status.unknown' })
    : fm({ id: 'orderView.status.unknown' });

export const getDerivedStatus = (orderTask) =>
  orderTask ? STATUS_BY_ORDER_TASK_STATUS[orderTask.orderTaskStatus] : STATUS.INACTIVE;

export const sortOrderTaskByOrderTaskStatus = (orderTask1, orderTask2) =>
  statusSortOrderByStatus[getDerivedStatus(orderTask2)] - statusSortOrderByStatus[getDerivedStatus(orderTask1)];

export const getOrderTaskByType = (orderTasks, findType) => {
  if (!orderTasks || orderTasks.length <= 0) {
    return null;
  }
  return [...orderTasks].sort(sortOrderTaskByOrderTaskStatus).find(({ orderTaskType: type }) => type === findType);
};
